
import Hex from "../../../assets/outline/Hex.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function HexIcon({ className, dataTestid = "HexIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Hex data-testid={dataTestid} className={classes} {...rest} />
  );
}
